import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MenuContainer, DropdownIcon, MenuHeader, Logo, CloseButton, MenuList, MenuItem, SubMenu, UserIcon, IconsContainer, UserIconContainer } from "./MenuMobile.style";
import MobileLogo from '../../assets/menu-mobile-logo.png'

const MenuMobile = ({setIsOpen, isOpen, isLoggedIn}) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [dropdowns, setDropdowns] = useState({
        lineas: false,
        contacto: false,
      });
    
      const toggleDropdown = (section) => {
        setDropdowns((prev) => ({
          ...prev,
          [section]: !prev[section],
        }));
      };

    return (
      <>
        <MenuContainer isOpen={isOpen}>
          <MenuHeader>
            <Logo>
                <Link to='/'><img src={MobileLogo} alt="Eupha Logo" /></Link>
            </Logo>
            <IconsContainer> 
              <CloseButton onClick={() => setIsOpen(false)} />
            </IconsContainer>
          </MenuHeader>
  
          <MenuList>
            <MenuItem bold onClick={() => setIsOpen(false)}><Link to='/'>EUPHA</Link></MenuItem>
            <MenuItem bold onClick={() => setIsOpen(false)}><Link to='/sobre-nosotros'>SOMOS EUPHA</Link></MenuItem>
              <>
                <MenuItem bold hasDropdown onClick={() => toggleDropdown("lineas")}>
                  <Link onClick={() => setIsOpen(false)} to='/lineas'>LÍNEAS</Link>
                  <DropdownIcon isOpen={dropdowns.lineas} />
                </MenuItem>
                <SubMenu isOpen={dropdowns.lineas}>
                  <MenuItem onClick={() => setIsOpen(false)} ><Link to='/lineas/dr-reckeweg/goteros/31'>Dr. Reckeweg</Link></MenuItem>
                  <MenuItem onClick={() => setIsOpen(false)}><Link to='/lineas/tegor/depuracion/140'>Tegor</Link></MenuItem>
                  <MenuItem onClick={() => setIsOpen(false)}><Link to='/lineas/symbio-pharm/symbioflor-1/262'>Symbiopharm</Link></MenuItem>
                  <MenuItem onClick={() => setIsOpen(false)}><Link to='/lineas/helixor/helixor-a/266'>Helixor</Link></MenuItem>
                  <MenuItem onClick={() => setIsOpen(false)}><Link to='/lineas/regenhial/regenhial/269'>Regenhial</Link></MenuItem>
                </SubMenu>
              </>
            <MenuItem bold onClick={() => setIsOpen(false)}><Link to='/eupha-world'>EUPHA WORLD</Link></MenuItem>
            <MenuItem bold hasDropdown onClick={() => toggleDropdown("contacto")}>
              <Link to='/contacto/contacto'>CONTACTO</Link>
              <DropdownIcon isOpen={dropdowns.contacto} />
            </MenuItem>
            <SubMenu isOpen={dropdowns.contacto}>
              <MenuItem onClick={() => setIsOpen(false)}><Link to='/contacto/contacto'>Contáctanos</Link></MenuItem>
              <MenuItem onClick={() => setIsOpen(false)}><Link to='/contacto/unete-al-equipo'>Únete al equipo</Link></MenuItem>
            </SubMenu>
          </MenuList>
        </MenuContainer>
      </>
    );
}

export default MenuMobile
